import type { Ceviri } from "../tip";
import type { ayarlar as tr } from "../tr/ayarlar";

/** English dictionary · ayarlar. */
export const ayarlar: Ceviri<typeof tr> = {
  ekran: {
    baslik: "Settings",
    aciklama: "Theme, storage details and data export/import.",
  },

  kaliciUyari: {
    baslik: "Take a backup before entering data",
    kaliciDegil: "Browser storage is not persistent.",
    persistOnce: " returned ",
    persistSonra:
      " in this environment — so the browser may delete the database without warning to free up space. Clearing site data has the same effect.",
    yuzdenOnEk: "So: in the ",
    depolama: "Storage",
    bolumunden: " section below, choose ",
    bulutDepolama: "cloud storage",
    secinYaDa: " (an encrypted copy of the vault is written to the cloud on every change), or take an ",
    sifreliYedek: "encrypted backup (.pfai)",
    sonEk: " file by hand and keep it off this device. The cloud copy opens with the vault password or the 24-word recovery phrase; if you lose both, it cannot be recovered. A backup downloaded by hand opens only with the password you entered when downloading it; an automatically downloaded backup opens like the cloud copy.",
  },

  sahte: {
    baslik: "Storage is currently FAKE",
    metin:
      "The interface is connected to an in-memory development fake instead of the real local core (SQLite + OPFS + Worker). Nothing you enter survives a page reload.",
  },

  gorunum: {
    baslik: "Appearance",
    tema: "Theme",
    uygulanan: (tema: string) => `Currently applied: ${tema}`,
    koyuKucuk: "dark",
    acikKucuk: "light",
    sistem: "System preference",
    acik: "Light",
    koyu: "Dark",
    koyuTema: "Dark theme",
    menuZemini: "Page background by menu section",
    iciZemin: "Tint sections within pages",
    zeminAciklama: "The tints only tell sections apart; they carry no meaning. The choice travels with the vault to your other devices.",
    dil: "Language",
    dilAciklama: "Your choice is stored only on this device. Changing it reloads the page.",
    kartSeti: "Holdings cards",
    kartSetiTemel: "Basic (5 cards)",
    kartSetiAyrintili: "Detailed (previous cards)",
    kartSetiAciklama: "Your choice is stored only on this device.",
  },

  depo: {
    baslik: "Storage details",
    semaSurumu: "Schema version",
    kaliciDepolama: "Persistent storage",
    evet: "yes",
    hayir: "no",
    tahminiKota: "Estimated quota",
    cihazKimligi: "Device ID",
    kayitliAyarlar: "Saved settings",
    okunuyor: "Reading settings…",
    okunamadi: "Settings could not be read.",
    bos: "No settings saved in storage.",
  },

  pfai: {
    baslik: "Encrypted backup (.pfai)",
    p1OnEk:
      "Your vault lives only in this browser. If you clear site data, the browser empties its storage or you change device, ",
    p1Kalin: "the vault is gone.",
    p1SonEk: " An encrypted backup is the only form in which the vault can leave the device.",
    p2OnEk: "Encryption happens ",
    p2Kalin1: "on this device",
    p2Orta: ": the password and data never reach the server. The price is this — ",
    p2Kalin2: "if you lose the password, the file cannot be recovered.",
    p2SonEk: " No back door, no reset.",
    parola: "Password",
    parolaTekrar: "Password (again)",
    sifreleniyorUc: "Encrypting…",
    sifreleniyor: "Encrypting",
    indir: "Download encrypted backup",
    parolalarFarkli: "The two passwords do not match.",
    indirildi: "Encrypted backup downloaded. Keep the password somewhere safe.",
    yedekTarihi: (an: string) => `Backup date: ${an}`,
    geriBaslik: "Restore from backup",
    g1OnEk: "Restoring ",
    g1Kalin1: "merges, it does not delete",
    g1Orta: ": records not in the backup stay where they are. If a record has two versions, ",
    g1Kalin2: "the newer version",
    g1SonEk: " wins — so restoring a backup does not take your vault back in time.",
    yedekParolasi: "Backup password",
    yedekParolasiIpucu: "For an automatically downloaded backup, the vault password.",
    dosyaSec: "Choose .pfai file",
    cozuluyor: "Decrypting",
    geriTamam: "Restore complete",
  },

  json: {
    baslik: "Unencrypted JSON (developer tool)",
    onEk: "UNENCRYPTED full backup — anyone who opens the file can read your whole portfolio. For normal backups use the ",
    sonEk: " format above; this is an emergency exit and a developer tool.",
    hazirlaniyor: "Preparing…",
    indir: "Download JSON",
    yukle: "Load from JSON",
    yukleniyor: "Loading",
    tamam: "Load complete",
  },

  nakit: {
    baslik: "Cash tracking",
    aciklama:
      "When on, Holdings shows the net cash movement per account (the cash effect of deposits, withdrawals, buys, sells, dividends and fees). Turn it off if you do not track your cash; dividends, interest and fees still count towards returns.",
    okunamadi: "Setting could not be read.",
    kaydedilemedi: "Setting could not be saved.",
    okunuyor: "Reading…",
    suAn: (durum: string) => `Currently: ${durum}`,
    acikKucuk: "on",
    kapaliKucuk: "off",
  },

  seansDisi: {
    baslik: "US extended-hours price",
    aciklama:
      "Pre-market (New York 04:00–09:30), after-hours (16:00–20:00) and overnight (20:00–04:00) trades on US exchanges are also tracked; the source gives no trade time for the overnight price, so the time it was fetched is shown. Choose which price today's value uses. Past days are always valued at the session close.",
    kapanis: "Session closing price",
    seansDisi: "Extended-hours price when newer",
  },

  abonelik: {
    baslik: "Subscription",
    acikKabiliyetler: "Active features",
    hal: {
      yukleniyor: "Checking…",
      sertifikasiz: "Free use. Paid features are unlocked with an activation code.",
      kapiYok: "This session does not connect to the subscription server; the vault is open with free limits.",
      suresiz: "Paid · no end date.",
      tarihineKadar: (gun: string) => `Paid · until ${gun}.`,
      sonTeyit: (an: string) =>
        `The server cannot be reached right now; last confirmed ${an}. ` +
        "If not confirmed within 48 hours, paid features close; your records are not deleted.",
      teyitEskidi:
        "The server has not been reachable for 48 hours; paid features are closed. They reopen by themselves once you are online.",
      suresiDoldu: "Paid features have expired. Your records were not deleted.",
      baskaCihazda: "This vault was opened on another device, so the paid session here was closed (session limit).",
      gecersiz: "The server did not recognise the certificates in this vault; paid features are closed.",
    },
    hata: {
      kodYok: "Code not recognised or already used.",
      gecersiz: "Invalid code format.",
      muhur: "This code cannot be used on this server.",
      cokDeneme: "Too many attempts; try again in an hour.",
      ulasilamadi: "The subscription server could not be reached; try again shortly.",
      kapiYok: "This session does not connect to the subscription server.",
      buEkrandaYok: "subscription is not available on this screen",
      sertifikaYok: "the server sent no certificate",
      sertifikaOkunamadi: "the certificate sent by the server could not be read",
      sertifikaGecersiz: (sebep: string) => `the certificate sent by the server is invalid: ${sebep}`,
      baskaKasa: "the certificate was issued for another vault",
    },
    butunKabiliyetler: "all features",
    kodKullanildi: (adlar: string) => `Code used: ${adlar} unlocked.`,
    eskisiDustu: "The session limit was full, so the oldest session was closed.",
    yenidenAc: "Reopen on this device",
    sinirDoluysa: "If the limit is full, the oldest session closes.",
    kod: "Activation code",
    gonderiliyor: "Sending…",
    kodKullan: "Use code",
  },

  kilit: {
    ucretli: (ne: string) => `${ne} is a paid feature.`,
    etiket: "Paid feature",
    abonelik: "Subscription",
    sunucuYedegi: "Backup to the Parafon server is a paid feature (Subscription).",
    bulutYedegi: "Automatic backup to your own cloud is a paid feature (Subscription).",
    varlikSiniri: (eldeki: number, sinir: number) =>
      `This account holds ${eldeki} different assets; free use allows at most ${sinir} per account. Sells and further buys of assets already held can be entered.`,
    sanalHesap: "A virtual account",
    sanalFazlasi: (n: number) => `More than ${n} virtual ${n === 1 ? "account" : "accounts"}`,
    sanalB: "Type B (cash flow of real accounts)",
    dengeleme: "Rebalancing",
  },
  /** Kabiliyet adları (sözleşmedeki `KABILIYETLER` sırası). */
  kabiliyetAdi: {
    "gecis": "Paid upgrade pack",
    "ek-hesap": "Extra account",
    "ek-oturum": "Extra session",
    "ek-kasa": "Extra vault",
    "fiyat-gecmisi": "Price history (5-year block)",
    "gecmis-gun": "Holdings: a past day",
    "donemsel-getiri": "Period Returns",
    "sanal-hesap": "Virtual account (pack of three)",
    "sanal-b": "Virtual account: type B",
    "sanal-dengeleme": "Virtual account: rebalancing",
    "sanal-paylasim": "Virtual account: sharing",
    "ice-aktarma": "Import (CSV)",
    "kurum-ekstresi": "Import from institution statements",
    "depolama-bulut": "Automatic backup to your own cloud",
    "depolama-sunucu": "Backup to the Parafon server",
    "depolama-kota": "Backup quota",
    "surum-gecmisi": "Backup version history",
  },
};
